
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21.2C17.081 21.2 21.2 17.081 21.2 12C21.2 6.91898 17.081 2.8 12 2.8C6.91898 2.8 2.8 6.91898 2.8 12C2.8 17.081 6.91898 21.2 12 21.2ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z","fill":"#16171F"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"11","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.0909 6.95996C13.0909 6.35747 12.6025 5.86905 12 5.86905C11.3975 5.86905 10.9091 6.35747 10.9091 6.95996V7.04723C10.9091 7.64972 11.3975 8.13814 12 8.13814C12.6025 8.13814 13.0909 7.64972 13.0909 7.04723V6.95996ZM11.1 17.7272C11.1 18.2795 11.5029 18.7272 12 18.7272C12.497 18.7272 12.9 18.2795 12.9 17.7272L12.9 11.131C12.9 10.5787 12.497 10.131 12 10.131C11.5029 10.131 11.1 10.5787 11.1 11.131L11.1 17.7272Z","fill":"white"}})])
          )
        }
      }
    